import * as React from 'react';
import Pagination from '../../containers/Pagination';
import Loading from '../partials/Loading';
import {getTagByPath} from '../../utils';
import AllArticles from '../partials/AllArticles';
import BugFixes from '../BugFixes';
import {History} from 'history';
import NoResultsPage from '../NoResultsPage';

export interface BasicLayoutProps {
  loading: boolean;
  articles: any[];
  experiments?: any[];
  history: History;
}

class BasicLayout extends React.Component<BasicLayoutProps, {}> {
  render() {
    const {history, articles, loading, experiments = []} = this.props;
    const tag = getTagByPath(history.location.pathname, this.props.experiments);
    if (articles.length === 0) {
      return <NoResultsPage history={history}/>;
    }
    return (
      <div data-hooks="basic-component">
        <Loading active={loading} />
        {tag === 'bug-fixes' ? (
          <BugFixes articles={articles} />
        ) : (
          <AllArticles articles={articles} experiments={experiments} />
        )}
        <Pagination history={history} />
      </div>
    );
  }
}
export default BasicLayout;
